import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "organisation-structure",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "organizational-structure" */ "./components/OrganizationalStructure"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
